/* 🤖 this file was generated by svg-to-ts */
export const matIconAutoAwesomeMosaic: {
  name: 'auto-awesome-mosaic';
  data: string;
} = {
  name: 'auto-awesome-mosaic',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 5v14a2 2 0 0 0 2 2h6V3H5a2 2 0 0 0-2 2zm6 14H5V5h4v14zM19 3h-6v8h8V5c0-1.1-.9-2-2-2zm0 6h-4V5h4v4zm-6 12h6c1.1 0 2-.9 2-2v-6h-8v8zm2-6h4v4h-4v-4z"/></svg>`
};
